<template>
  <VanSelect
    v-model="selectValue"
    multiple
    :options="options"
    placeholder="全部来源"
    title="数据来源"
    @change="handleChange"
  />
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { getSource } from '@/api/ai-board'
import VanSelect from '@/components/VanSelect.vue'
import { AllSourceTypeMap } from '@/constants/source-type-map'

defineOptions({
  name: 'MobileSourceTypeSelect'
})

const props = defineProps({
  value: {
    type: Array,
    default: () => []
  },
  activeTab: {
    type: String,
    default: '' // 当前看板tab类型
  }
})

const emits = defineEmits(['update:value', 'change'])

const options = ref([])

const selectValue = computed({
  get() {
    return props.value
  },
  set(newValue) {
    emits('update:value', newValue)
  }
})

const handleChange = (value) => {
  emits('change', value)
}

const getSourceList = async () => {
  try {
    const res = await getSource()
    const result = res.result || {}
    // TODO: 兼容特殊业务场景【员工跟进日程、员工跟进Pk】看板下，不展示【群聊Tab】
    const hasWechatGroup = !['meetingAssessment'].includes(props.activeTab)
    options.value = AllSourceTypeMap.filter(({ key }) => result[key] === 1).filter((val) => {
      return val.value === 11 ? hasWechatGroup : true
    })
  } catch (err) {
    console.log(err)
    options.value = [{ value: 1, label: '手动上传音视频' }]
  }
}

onMounted(() => {
  getSourceList()
})
</script>
